/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
:host {
  display: block;
}

:host([variant=vast]) {
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  font-size: 44px;
}
@media only screen and (width >= 1920px) {
  :host([variant=vast]) {
    font-size: 66px;
  }
}
@media only screen and (width <= 1439px) {
  :host([variant=vast]) {
    font-size: 34px;
  }
}
@media only screen and (width <= 767px) {
  :host([variant=vast]) {
    font-size: 28px;
  }
}

:host([variant=giant]) {
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  font-size: 34px;
}
@media only screen and (width >= 1920px) {
  :host([variant=giant]) {
    font-size: 44px;
  }
}
@media only screen and (width <= 1439px) {
  :host([variant=giant]) {
    font-size: 28px;
  }
}
@media only screen and (width <= 767px) {
  :host([variant=giant]) {
    font-size: 23px;
  }
}

:host([variant=big]) {
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  font-size: 28px;
}
@media only screen and (width >= 1920px) {
  :host([variant=big]) {
    font-size: 34px;
  }
}
@media only screen and (width <= 1439px) {
  :host([variant=big]) {
    font-size: 23px;
  }
}
@media only screen and (width <= 767px) {
  :host([variant=big]) {
    font-size: 20px;
  }
}

:host([variant=medium]) {
  margin-block-start: 1em;
  margin-block-end: 1em;
  font-size: 23px;
}
@media only screen and (width >= 1920px) {
  :host([variant=medium]) {
    font-size: 28px;
  }
}
@media only screen and (width <= 1439px) {
  :host([variant=medium]) {
    font-size: 20px;
  }
}

:host([variant=small]) {
  margin-block-start: 1em;
  margin-block-end: 1em;
  font-size: 20px;
  line-height: 1.25;
}
@media only screen and (width >= 1920px) {
  :host([variant=small]) {
    font-size: 23px;
  }
}

:host([strong]) {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
}